export default __webpack_public_path__ + "static/media/2829 utensils top.8ded63db.png";